/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentParcelsParcelidSerials200,
  GetApiV1IndividualpaymentParcelsParcelidSerials401,
  GetApiV1IndividualpaymentParcelsParcelidSerials500,
  GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams,
  GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse,
} from "../../types/individualPaymentParcelsController/GetApiV1IndividualpaymentParcelsParcelidSerials.ts";
import { individualPaymentPaymentSerialViewModelSchema } from "../individualPaymentPaymentSerialViewModelSchema.ts";

export const getApiV1IndividualpaymentParcelsParcelidSerialsPathParamsSchema =
  z.object({
    parcelId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidSerialsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentParcelsParcelidSerials200Schema = z.array(
  z.lazy(() => individualPaymentPaymentSerialViewModelSchema),
) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidSerials200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentParcelsParcelidSerials401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidSerials401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentParcelsParcelidSerials500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidSerials500>;

export const getApiV1IndividualpaymentParcelsParcelidSerialsQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentParcelsParcelidSerials200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentParcelsParcelidSerialsQueryResponse>;
